import { useEffect, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { QueryKeys } from '@/app/_utils/react-query'

interface Props {
    slug: string
}

export default function usePDPInitialLoading({ slug }: Props) {
    const [isLoading, setIsLoading] = useState(true)
    const [shouldSendRequest, setShouldSendRequest] = useState(true)

    const queryClient = useQueryClient()

    useEffect(() => {
        const init = async () => {
            if (shouldSendRequest) {
                await queryClient.refetchQueries({ queryKey: QueryKeys.PDP.ProductData(slug) })

                setShouldSendRequest(false)

                setIsLoading(false)
            }
        }

        init()
    }, [queryClient, slug, shouldSendRequest])

    return isLoading
}
